import { render, staticRenderFns } from "./OrderProductList.vue?vue&type=template&id=90a25d6e&scoped=true&"
import script from "./OrderProductList.vue?vue&type=script&lang=js&"
export * from "./OrderProductList.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductList.vue?vue&type=style&index=0&id=90a25d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a25d6e",
  null
  
)

export default component.exports